import { render, staticRenderFns } from "./ApplicantL1.vue?vue&type=template&id=6a1fe1d6&"
import script from "./ApplicantL1.vue?vue&type=script&lang=js&"
export * from "./ApplicantL1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports